"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObstacleRuleName = exports.SubtaskSprintStrategy = exports.RetroHighlightChangeDirection = exports.RetroHighlightValueType = exports.ObstacleDetailsType = exports.ObstacleSubCategory = exports.ObstacleCategory = exports.ObstacleEffect = void 0;
var ObstacleEffect;
(function (ObstacleEffect) {
    ObstacleEffect["NotAvailable"] = "NOT_AVAILABLE";
    ObstacleEffect["Low"] = "LOW";
    ObstacleEffect["Medium"] = "MEDIUM";
    ObstacleEffect["High"] = "HIGH";
    ObstacleEffect["Critical"] = "CRITICAL";
})(ObstacleEffect = exports.ObstacleEffect || (exports.ObstacleEffect = {}));
var ObstacleCategory;
(function (ObstacleCategory) {
    ObstacleCategory["Output"] = "OUTPUT";
    ObstacleCategory["Velocity"] = "VELOCITY";
    ObstacleCategory["Quality"] = "QUALITY";
})(ObstacleCategory = exports.ObstacleCategory || (exports.ObstacleCategory = {}));
var ObstacleSubCategory;
(function (ObstacleSubCategory) {
    ObstacleSubCategory["Internal"] = "INTERNAL";
    ObstacleSubCategory["External"] = "EXTERNAL";
})(ObstacleSubCategory = exports.ObstacleSubCategory || (exports.ObstacleSubCategory = {}));
var ObstacleDetailsType;
(function (ObstacleDetailsType) {
    ObstacleDetailsType["Task"] = "TASK";
    ObstacleDetailsType["PullRequest"] = "PULL_REQUEST";
})(ObstacleDetailsType = exports.ObstacleDetailsType || (exports.ObstacleDetailsType = {}));
var RetroHighlightValueType;
(function (RetroHighlightValueType) {
    RetroHighlightValueType["Task"] = "TASK";
    RetroHighlightValueType["Bug"] = "BUG";
    RetroHighlightValueType["Percentage"] = "PERCENTAGE";
    RetroHighlightValueType["TimeSeconds"] = "TIME_SECONDS";
    RetroHighlightValueType["StoryPoints"] = "STORY_POINTS";
})(RetroHighlightValueType = exports.RetroHighlightValueType || (exports.RetroHighlightValueType = {}));
var RetroHighlightChangeDirection;
(function (RetroHighlightChangeDirection) {
    RetroHighlightChangeDirection["Positive"] = "POSITIVE";
    RetroHighlightChangeDirection["Negative"] = "NEGATIVE";
})(RetroHighlightChangeDirection = exports.RetroHighlightChangeDirection || (exports.RetroHighlightChangeDirection = {}));
var SubtaskSprintStrategy;
(function (SubtaskSprintStrategy) {
    SubtaskSprintStrategy["IGNORE_SUBTASKS"] = "IGNORE_SUBTASKS";
    SubtaskSprintStrategy["IGNORE_PARENTS"] = "IGNORE_PARENTS";
    SubtaskSprintStrategy["IGNORE_NONE"] = "IGNORE_NONE";
})(SubtaskSprintStrategy = exports.SubtaskSprintStrategy || (exports.SubtaskSprintStrategy = {}));
var ObstacleRuleName;
(function (ObstacleRuleName) {
    ObstacleRuleName["UnplannedWork"] = "Unplanned work";
    ObstacleRuleName["TaskContentChanges"] = "Task content changes";
    ObstacleRuleName["TaskPriorityChanges"] = "Priority changes";
    ObstacleRuleName["LongReviews"] = "Long reviews";
    ObstacleRuleName["TasksOutOfSprintScope"] = "Tasks out of iteration scope";
    ObstacleRuleName["WastedWork"] = "Wasted work";
    ObstacleRuleName["FixBugRate"] = "High bug fix rate";
    ObstacleRuleName["PullRequestMergedWithoutApproval"] = "Pull request merged without approval";
    ObstacleRuleName["PullRequestRubberStamped"] = "Quick reviews";
})(ObstacleRuleName = exports.ObstacleRuleName || (exports.ObstacleRuleName = {}));
//# sourceMappingURL=retro.js.map